module.exports = __webpack_public_path__ + "img/amount-img.0e4a26cc.png";